import { Check } from "lucide-react";

import { cn } from "@/shared/lib/utils";

import type { CardGradient } from "../../constants/cardGradients";

export interface GradientSwatchProps {
  gradient: CardGradient;
  selected: boolean;
  disabled?: boolean;
  onClick: () => void;
}

export function GradientSwatch({ gradient, selected, disabled = false, onClick }: GradientSwatchProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-pressed={selected}
      aria-label={gradient.name}
      className={cn(
        "group relative aspect-[1.586/1] overflow-hidden rounded-lg text-left transition-all",
        "ring-offset-2 ring-offset-background",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
        selected
          ? "ring-2 ring-primary shadow-md"
          : "ring-1 ring-border hover:ring-2 hover:ring-muted-foreground",
        disabled && "opacity-50 pointer-events-none",
      )}
      style={{ background: gradient.css }}
    >
      <span
        aria-hidden="true"
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse 80% 60% at 80% 0%, rgba(255,255,255,0.18), transparent 60%), radial-gradient(ellipse 100% 80% at 0% 100%, rgba(255,255,255,0.10), transparent 60%)",
        }}
      />
      <span className="absolute inset-x-0 bottom-0 flex items-center justify-between px-2 py-1.5">
        <span className="text-[10px] font-medium uppercase tracking-wider text-white/90">
          {gradient.name}
        </span>
        {selected && (
          <span className="inline-flex h-4 w-4 items-center justify-center rounded-full bg-white text-primary">
            <Check size={11} strokeWidth={2.5} />
          </span>
        )}
      </span>
    </button>
  );
}
